import { campaignGroupApi } from 'services/api';
import {
    fetchCampaignGroupsListError,
    fetchCampaignGroupsListSuccess,
    requestFetchCampaignGroupsList,
} from '../actions';

const PAGE_SIZE = 20;

export const fetchCampaignGroupsList = ({
    accountName,
    page,
    pageSize = PAGE_SIZE,
    searchText,
    sort,
    apiCacheKey,
    allowMultiRequestCache,
}) => {
    return async dispatch => {
        dispatch(requestFetchCampaignGroupsList());
        try {
            const { results, metadata } = await campaignGroupApi.getCampaignGroupList(accountName, {
                page,
                pageSize,
                searchText,
                sort,
                singleRequestCacheKey: apiCacheKey,
                allowMultiRequestCache,
            });

            dispatch(fetchCampaignGroupsListSuccess({ results, metadata }));
            return [results, metadata.total ?? 0];
        } catch (error) {
            dispatch(fetchCampaignGroupsListError(error));
            return [[]];
        }
    };
};
